(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('TimeseriesDataOpen', TimeseriesDataOpen);

    TimeseriesDataOpen.$inject = ['$resource', 'DateUtils'];

    function TimeseriesDataOpen ($resource, DateUtils) {
        var resourceUrl =  'api/open/timeseries-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.date = DateUtils.convertLocalDateFromServer(data.date);
                    }
                    return data;
                }
            }
        });
    }
})();
